const data = [
    {
        name: "Prof. Adrijit Goswami",
        position: "",
        imageUrl: "/assets/images/members/Prof. Adrijit Goswami.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Prof. Amit Patra",
        position: "",
        imageUrl: "/assets/images/members/Prof. Amit Patra.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Dr. Bhaskar Bhowmik",
        position: "",
        imageUrl: "/assets/images/members/Dr. Bhaskar Bhowmik.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Prof. Damodar Maiti",
        position: "",
        imageUrl: "/assets/images/members/Prof. Damodar Maiti.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Prof. D.K. Maiti",
        position: "",
        imageUrl: "/assets/images/members/Prof. D.K. Maiti.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Prof. Dilip Swain",
        position: "",
        imageUrl: "/assets/images/members/Prof. Dilip Swain.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Retd. Prof. H.R. Tiwari",
        position: "",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Prof. Sasmita Mohakud",
        position: "",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Prof. Sudipta Datta",
        position: "",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Prof. Sudipto Chakraborty",
        position: "",
        imageUrl: "/assets/images/members/Prof. Sudipto Chakraborty.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },

]

export default data;